<template>
  <div class="seccion-productos-inv">
    <div class="container text texto-intro m-y-2-lg m-y-1-sm">
      <h1>Productos de Investigación</h1>
      <p class="intro">
        El presente apartado pone a disposición de la comunidad científica, las 
        instituciones públicas y privadas, organizaciones de base comunitarias y 
        sociedad en general un acervo de información relacionada con el Lago de Texcoco.
      </p>
    </div>
    <div class="container">
      <!-- Fichas -->
      <div class="contenedor-fichas m-t-2">
        <TarjetaLista
          class="perfiles-suelo"
          titulo="Perfiles de suelo y sedimentos lacustres"
          :portada="require('@/assets/img/portada-perfiles-de-suelo.png')"
        />

        <TarjetaListaDescargas
          titulo="Fichas"
          :elementos="[
            {
              id: 1,
              nombre: 'Fichas ANP',
              url: 'https://1drv.ms/u/s!Aubg4PSdkCoigihWmiKFhUiDjLxb?e=Rqu5MB',
              peso: '6.3 MB',
              formato: 'zip',
            },
            {
              id: 2,
              nombre: 'Fichas Minas',
              url: 'https://1drv.ms/u/s!Aubg4PSdkCoigipaq20EMmTVLEhd?e=wcUUi4',
              peso: '12.4 MB',
              formato: 'ZIP',
            },
          ]"
          :conIconoDeDescarga="true"
        />
      </div>

      <div class="galeria-productos-inv m-b-1">
        <p class="subtitulo">Mapas</p>

        <div class="contenedor-descarga">
          <p class="texto-notas">
            <span v-if="mapasSeleccionados.length == 1">1 selecciondo de </span>
            <span v-if="mapasSeleccionados.length > 1">
              {{ mapasSeleccionados.length }} selecciondos de
            </span>
            {{ listaFiltradaPorCategoria().length }} descargas disponibles
          </p>
          <button
            v-if="mapasSeleccionados.length > 0 && !vistaSimplificada"
            class="btn-descargar"
            @click="descragarMapas()"
          >
            {{ etiquetaDescargaPorSeleccion() }}
            <span class="icono icono-descargar" />
          </button>
        </div>

        <!-- Selector de clasificaciones -->
        <div class="contenedor-menu-selector">
          <p>Selecciona los mapas que desees descargar</p>
          <select v-model="categoriaSeleccionada">
            <option value="todes">Todos los mapas</option>
            <option
              v-for="categoria of obtenerCategorias()"
              :key="`opcion_${categoria}`"
              v-bind:value="categoria"
            >
              {{ categoria }}
            </option>
          </select>
        </div>

        <!-- Mapas en lista (solo en a11y-simplificada) -->
        <div v-if="vistaSimplificada" class="lista-mapas a11y-simplificada">
          <div
            v-for="(productoInv, idx) in listaCargada
              ? listaFiltradaPorCategoria()
              : []"
            :key="idx"
          >
            <a
              class="imagen-encabezado"
              @click="descragarArchivo(productoInv.archivo, productoInv.url)"
            >
              <p class="nombre">{{ productoInv.titulo }}</p>
              <span class="detalles"
                >JPG <b>{{ productoInv.peso }}</b></span
              >
            </a>
          </div>
        </div>

        <div v-if="!vistaSimplificada">
          <!-- Mapas en cuadricula -->
          <div
            class="grid-mapas"
            v-for="(grupo, idGrupo) in agruparLista(
              listaCargada ? listaPaginada()[paginaActual] : [],
              5
            )"
            :key="idGrupo"
          >
            <div
              v-for="(productoInv, idxProd) in grupo"
              :key="`${idGrupo}.${idxProd}`"
              :class="`box box-${idxProd + 1}`"
            >
              <label :for="`imagen${idGrupo}.${idxProd}`">
                <input
                  type="checkbox"
                  :value="productoInv"
                  :id="`imagen${idGrupo}.${idxProd}`"
                  v-model="mapasSeleccionados"
                />

                <div class="imagen-encabezado">
                  <p class="nombre">{{ productoInv.titulo }}</p>
                  <span class="detalles"
                    >JPG <b>{{ productoInv.peso }}</b></span
                  >
                </div>
              </label>

              <img
                :alt="productoInv.titulo"
                @click="abrirModal(idGrupo, idxProd)"
                :src="`${ruta}/miniaturas/${productoInv.archivo.replace(
                  'png',
                  'jpg'
                )}`"
              />
            </div>
          </div>

          <!-- Numerador de páginas -->
          <Paginador
            @cambiarPagina="paginaActual = $event"
            :nPaginas="listaPaginada().length"
            :paginaActual="paginaActual"
          />
        </div>

        <!-- Modal de imagen -->
        <Modal ref="modal_imagen" class="modal-imagen">
          <template v-slot:encabezado>
            <div class="modal-encabezado">
              <div class="imagen-encabezado">
                <p class="nombre">
                  <b>{{ contenidoEnModal.titulo }}</b>
                </p>
                <span class="detalles"
                  >JPG <b>{{ contenidoEnModal.peso }}</b></span
                >
              </div>
              <button
                class="btn-descargar"
                @click="
                  descragarArchivo(
                    contenidoEnModal.archivo,
                    contenidoEnModal.url
                  )
                "
              >
                Descargar<span class="icono icono-descargar" />
              </button>
            </div>
          </template>

          <template v-slot:cuerpo>
            <div class="modal-cuerpo">
              <div class="botones">
                <button
                  class="btn-icono icono-descargar anterior"
                  @click="modalAnterior()"
                />
                <button
                  class="btn-icono icono-descargar posterior"
                  @click="modalSigueinte()"
                />
              </div>
              <img
                :alt="contenidoEnModal.archivo"
                :src="contenidoEnModal.url"
                @load="imagenModalCargada()"
              />
            </div>
          </template>

          <template v-slot:pie>
            <div class="modal-pie">
              <button class="btn-descargar">
                Descargar<span class="icono icono-descargar" />
              </button>
            </div>
          </template>
        </Modal>
      </div>
    </div>
  </div>
</template>

<script>
import TarjetaLista from "@/components/TarjetaLista.vue";
import TarjetaListaDescargas from "@/components/TarjetaListaDescargas.vue";
import Paginador from "@/components/Paginador.vue";
import Modal from "@/components/Modal.vue";

import {
  blobDelArchivo,
  descargarArchivo,
  ArchivoParaComprimir,
  comprimirArchivos,
} from "@/components/_descargas.js";
import { quitarLoader, mostrarLoader } from "@/components/_utils.js";

const elementosPorPagina = 10;
const listaArchivos = "lista-de-productos-inv-mapas.csv";

export default {
  data() {
    return {
      perfilesSuelo: Paginador.methods.rango(43).map((i) => ({
        id: i,
        nombre: `Perfiles de suelo ${i + 1}`,
        url: listaArchivos[i],
      })),

      ruta: "descargables/productos-de-investigacion",
      listaCargada: false,
      listaMapas: [],
      mapasSeleccionados: [],
      categoriaSeleccionada: "todes",
      paginaActual: 0,
      contenidoEnModal: undefined,
      idxcontenidoEnModal: undefined,
      imgModalCargada: false,
    };
  },
  mounted() {
    this.cargarDatos();
  },
  computed: {
    vistaSimplificada: {
      get() {
        return this.$store.state.vista_simplificada;
      },
    },
  },
  methods: {
    cargarDatos() {
      const lecturaArchivo = fetch(`${this.ruta}/${listaArchivos}`);
      const alCargar = (lista) => {
        this.listaMapas = lista;
        this.listaCargada = true;
        quitarLoader();
      };

      if (listaArchivos.includes(".csv")) {
        lecturaArchivo
          .then((r) => (r.ok ? r.text() : "error al cargar"))
          .then((d) => {
            const renglones = d
              .split("\n")
              .filter((r) => r !== "")
              .map((r) => r.replace("\r", "").split(","));
            const titulos = renglones[0];
            renglones.shift();
            alCargar(
              renglones.map((r) =>
                Object.fromEntries(titulos.map((t, i) => [t, r[i]]))
              )
            );
          });
      } else {
        lecturaArchivo
          .then((r) => (r.ok ? r.json() : ["error al cargar"]))
          .then((d) => alCargar(d));
      }
    },
    listaFiltradaPorCategoria() {
      return this.categoriaSeleccionada === "todes"
        ? this.listaMapas
        : this.listaMapas.filter(
            (i) => i.clasificacion === this.categoriaSeleccionada
          );
    },
    agruparLista(lista, elementosPorGrupo) {
      let grupo = [],
        grupos = [];
      lista.forEach((a, i) => {
        grupo.push(a);
        if ((i + 1) % elementosPorGrupo == 0) {
          grupos.push(grupo);
          grupo = [];
        }
      });
      if (grupo.length) grupos.push(grupo);
      return grupos;
    },
    listaPaginada() {
      return this.agruparLista(
        this.listaFiltradaPorCategoria(),
        elementosPorPagina
      );
    },
    obtenerCategorias() {
      return [...new Set(this.listaMapas.map((i) => i.clasificacion))];
    },
    etiquetaDescargaPorSeleccion() {
      if (
        this.mapasSeleccionados.length == 0 ||
        this.mapasSeleccionados.length == this.listaMapas.length
      ) {
        return "Descargar todo";
      } else if (this.mapasSeleccionados.length == 1) return "Descargar imagen";
      else return "Descargar imágenes";
    },

    async descragarMapas() {
      mostrarLoader(this.vistaSimplificada);
      let blob = undefined,
        nombreDescarga = undefined;
      if (
        this.mapasSeleccionados.length == 0 ||
        this.mapasSeleccionados.length == this.listaMapas.length
      ) {
        // descargar todo
        /**
         * Si tarda mucho al descargar este zip por url otra opción es
         * validar esta parte y que la forma de descargar el zip sea
         * con un href, y así quitarle trabajo al navehgador
         */
        blob = await blobDelArchivo(
          /***** AQUÍ URL DE ZIP CON TODAS LAS IMAGENES *****/ "descargables/productos/MAPAS.zip"
        );
        nombreDescarga = "MAPAS.zip";
      } else if (this.mapasSeleccionados.length == 1) {
        // descargar una imagen
        blob = await blobDelArchivo(this.mapasSeleccionados[0].url);
        nombreDescarga = this.mapasSeleccionados[0].archivo;
      } else {
        // construir zip
        const archivosParaComprimir = this.mapasSeleccionados.map(
          (img) => new ArchivoParaComprimir(img.archivo, img.url)
        );

        blob = await comprimirArchivos(archivosParaComprimir);
        nombreDescarga = "MAPAS-seleccionados.zip";
      }
      await descargarArchivo(nombreDescarga, blob);
      quitarLoader();
    },
    async descragarArchivo(nombreDescarga, url) {
      mostrarLoader(this.vistaSimplificada);
      const blob = await blobDelArchivo(url);
      await descargarArchivo(nombreDescarga, blob);
      quitarLoader();
    },
    abrirModal(idGrupo, idx) {
      this.idxcontenidoEnModal = idx + 5 * idGrupo;
      this.contenidoEnModal =
        this.listaPaginada()[this.paginaActual][this.idxcontenidoEnModal];
      //console.log(idGrupo,idx,this.listaPaginada())
      this.$refs.modal_imagen.abrirModal();
      mostrarLoader(this.vistaSimplificada);
    },
    modalSigueinte() {
      const listaPaginaActual = this.listaPaginada()[this.paginaActual];
      this.idxcontenidoEnModal++;
      if (listaPaginaActual.length == this.idxcontenidoEnModal)
        this.idxcontenidoEnModal = 0;
      this.contenidoEnModal = listaPaginaActual[this.idxcontenidoEnModal];
      mostrarLoader(this.vistaSimplificada);
    },
    modalAnterior() {
      const listaPaginaActual = this.listaPaginada()[this.paginaActual];
      this.idxcontenidoEnModal--;
      if (this.idxcontenidoEnModal < 0)
        this.idxcontenidoEnModal = listaPaginaActual.length - 1;
      this.contenidoEnModal = listaPaginaActual[this.idxcontenidoEnModal];
      mostrarLoader(this.vistaSimplificada);
    },
    imagenModalCargada() {
      quitarLoader();
    },
  },
  components: {
    TarjetaLista,
    Modal,
    Paginador,
    TarjetaListaDescargas,
  },
};
</script>

<style scoped lang="scss">
.btn-descargar {
  border: 1px solid #141414;
  border-radius: 5px;
  color: #141414;
  background-color: white;
  display: inline-flex;
  height: 35px;
  span.icono {
    font-size: 36px;
    margin-left: 6px;
  }
  &:hover {
    color: white;
    background-color: #141414;
  }
}

.lista-mapas.a11y-simplificada {
  max-height: 500px;
  overflow: auto;
  .imagen-encabezado {
    display: flex;
    flex-direction: column;
    font-size: 14px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    margin: 0;
    padding: 3.75px 4px;
    align-items: flex-start;
    justify-content: space-between;
  }

  @media (min-width: map-get($media-queries-limit, "mobile")) {
    font-size: 16px;
  }
}

.imagen-encabezado {
  // width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  @media (max-width: map-get($media-queries-limit, "mobile")) {
    white-space: normal;
  }
  .nombre {
    margin: 0;
  }
  .detalles > b {
    color: #505050;
    margin-left: 8px;
  }
}

.modal-imagen {
  .modal-encabezado {
    width: 100%;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    .imagen-encabezado {
      .nombre {
        font-size: 22px;
      }
      .detalles {
        font-size: 18px;
      }
    }
    @media (max-width: calc(map-get($media-queries-limit, "mobile")) - 1) {
      .btn-descargar {
        display: none;
      }
    }
  }
  .modal-cuerpo {
    .botones {
      position: absolute;
      width: calc(100% + 20px);
      right: -10px;
      top: 50%;
      display: flex;
      justify-content: space-between;
      .btn-icono {
        border-radius: 50%;
        width: 42px;
        height: 42px;
        background-color: #000;
        color: #fff;
      }
      .anterior {
        transform: rotate(90deg);
      }
      .posterior {
        transform: rotate(-90deg);
      }
    }
    img {
      width: 100%;
    }
  }
  .modal-pie {
    width: 100%;
    display: inline-flex;
    justify-content: center;
    margin-top: 10px;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      display: none;
    }
  }
}

.seccion-productos-inv {
  .contenedor-fichas {
    display: grid;
    grid-gap: $gap * 0.5;
    @media (min-width: map-get($media-queries-limit, "mobile")) {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: $gap;
    }
  }
  .galeria-productos-inv {
    > .subtitulo {
      margin-bottom: 0;
      border-bottom: 1px solid #505050;
    }
    .contenedor-descarga,
    .contenedor-menu-selector {
      display: flex;
      justify-content: space-between;
      flex-direction: column-reverse;
      margin-block: 10px;
      p {
        margin-top: 0;
      }
      select {
        margin: 0;
        min-width: 300px;
        height: 35px;
        border: none;
        box-shadow: 0px 3px 6px #00000029;
        &:focus {
          border-color: map-get($color-formulario, "focus-borde");
          box-shadow: 0 3px 9px rgba(0,0,0,.1);
          color: map-get($color-formulario, "focus-texto");
          outline: none;
        }
      }
      @media (min-width: map-get($media-queries-limit, "mobile")) {
        flex-direction: row;
        align-items: center;
      }
    }
    .grid-mapas {
      .box {
        box-shadow: 0px 3px 6px #00000029;
        border-radius: 10px;
        padding: 5px;
        label {
          cursor: pointer;
          width: calc(100% - 10px);
          position: absolute;
          display: flex;
          align-items: center;
          @media (max-width: map-get($media-queries-limit, "mobile")) {
            width: calc(90% - 10px);
          }
          input[type="checkbox"] {
            min-width: 25px;
            width: 25px;
            max-width: 25px;
            height: 25px;
            margin: 5px !important;
            padding: 0 !important;
          }
          .imagen-encabezado {
            .nombre {
              font-size: 12px;
            }
            .detalles {
              font-size: 12px;
            }
          }
        }
        img {
          padding-top: 40px;
          width: 100%;
          height: 100%;
          @media (max-width: map-get($media-queries-limit, "mobile")) {
            padding-top: 55px;
          }
          &:hover {
            cursor: pointer;
          }
        }
      }
    }
  }

  .contenedor-grid,
  .galeria-productos-inv {
    .grid-mapas {
      display: grid;
      grid-template-columns: repeat(auto-fill);
      grid-gap: $gap * 0.5;
      margin-bottom: $gap * 0.5;
      @media (min-width: map-get($media-queries-limit, "mobile")) {
        grid-template-columns: repeat(6, 1fr);
        grid-gap: $gap;
        margin-bottom: $gap;
        .box {
          position: relative;
        }
        .box-1 {
          grid-column: 1/5;
          grid-row: 1/3;
        }
        .box-2 {
          grid-column: 5/7;
          grid-row: 1;
        }
        .box-3 {
          grid-column: 5/7;
          grid-row: 2;
        }
        .box-4 {
          grid-column: 1/4;
          grid-row: 3;
        }
        .box-5 {
          grid-column: 4/7;
          grid-row: 3;
        }
      }
    }
  }

  input[type="checkbox"] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    border: 1px solid black;
    cursor: pointer;
    border-radius: 5px;
    margin-right: 0.5em;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 1.5em 1.5em;
    &:checked {
      background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="m186 340l-90-91-32 31 122 122 262-261-32-31z"></path></svg>');
      background-color: white;
    }
  }
}
</style>
